<template>
    <div style="height: 100%">
        <VencimentoList v-show="!rotaAninhada" :reloadData="reloadData" />
        <router-view />
    </div>
</template>

<script>
import VencimentoList from '@/components/promotor/relatorio-analitico/relatorio-vencimento/RelatorioVencimentoList.vue';

export default {
    name: 'RelatorioVencimentoListRoute',

    beforeRouteUpdate(to, from, next) {
        this.rotaAninhada = to.name != 'relatorio-pro-vencimento-list';
        if (
            from.name != 'relatorio-pro-vencimento-list' &&
            to.name == 'relatorio-pro-vencimento-list'
        ) {
            this.reloadData = true;
            setTimeout(() => (this.reloadData = false), 300);
        }
        next();
    },
    components: {
        VencimentoList,
    },
    data() {
        return {
            rotaAninhada: false,
            reloadData: false,
        };
    },
    created() {
        this.rotaAninhada =
            this.$route.name.includes('relatorio-pro-vencimento') &&
            this.$route.name != 'relatorio-pro-vencimento-list';
    },
};
</script>
